import { atom } from 'jotai';

export const newsletterAtom = atom(false);
